<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g style="fill:#fff;stroke:#adadad"><circle cx="12" cy="12" r="12" stroke="none" style="stroke:none"/><circle cx="12" cy="12" r="11.5" style="fill:none"/></g><g style="opacity:.8"><path d="M0 0v10" style="stroke:#333;stroke-linecap:round;fill:none" transform="rotate(-45 14.45 -5.984)" fill="currentColor"/><path d="M0 0v10" style="stroke:#333;stroke-linecap:round;fill:none" transform="rotate(45 -2.45 22.985)" fill="currentColor"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-btn-del',
});
</script>
